// import { toBigInt } from "ethers";

// export function spacingForFee(fee) {
//   if (fee === 100) return 1;
//   if (fee === 500) return 10;
//   if (fee === 3000) return 60;
//   return 200; // 1% = 10000
// }
// export function encodeSqrtPriceX96(price, dec0, dec1) {
//   const scale = 10 ** (dec1 - dec0);
//   const sqrt = Math.sqrt(price * scale);
//   return toBigInt(Math.floor(sqrt * 2 ** 96));
// }
// export function nearestUsableTick(tick, spacing) {
//   return Math.floor(tick / spacing) * spacing;
// }
// export function priceToTick(p) {
//   return Math.floor(Math.log(Number(p)) / Math.log(1.0001));
// }
export function spacingForFee(fee) {
  if (fee === 100) return 1;
  if (fee === 500) return 10;
  if (fee === 3000) return 60;
  return 200; // 1% = 10000
}
export function encodeSqrtPriceX96(price, dec0, dec1) {
  const scale = 10 ** (dec1 - dec0);
  const sqrt = Math.sqrt(price * scale);
  return Math.floor(sqrt * 2 ** 96);
}
export function nearestUsableTick(tick, spacing) {
  return Math.floor(tick / spacing) * spacing;
}
export function priceToTick(p) {
  return Math.floor(Math.log(Number(p)) / Math.log(1.0001));
}
